import { Button } from "@/components/ui/button";

/* Row of quick-filter chips. `options` = [{key, label}]; `value` is the active key ("" = none). */
export function QuickFilters({ options, value, onChange, testId = "quick-filters" }) {
  return (
    <div className="-mx-1 flex flex-wrap gap-1.5 px-1 pb-1" data-testid={testId}>
      {options.map((o) => {
        const active = value === o.key;
        return (
          <button key={o.key || "all"} type="button" onClick={() => onChange(active && o.key ? "" : o.key)} data-testid={`${testId}-${o.key || "all"}`}
            className={`shrink-0 rounded-full border px-3 py-1 font-mono text-[11px] uppercase tracking-wider transition-colors ${active ? "border-primary bg-primary text-primary-foreground" : "border-border bg-background text-muted-foreground hover:border-gold hover:text-foreground"}`}>
            {o.label}
          </button>
        );
      })}
    </div>
  );
}

export function Pager({ page, pages, onChange, testId = "pager" }) {
  if (pages <= 1) return null;
  return (
    <div className="flex items-center gap-1 font-mono text-xs" data-testid={testId}>
      <Button variant="outline" size="sm" className="rounded-full" disabled={page === 0} onClick={() => onChange(page - 1)} data-testid={`${testId}-prev`}>Prev</Button>
      <span className="px-2 text-muted-foreground">{page + 1} / {pages}</span>
      <Button variant="outline" size="sm" className="rounded-full" disabled={page >= pages - 1} onClick={() => onChange(page + 1)} data-testid={`${testId}-next`}>Next</Button>
    </div>
  );
}
